import React from 'react';
import { Instagram } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
interface Trainer {
  name: string;
  role: string;
  image: string;
  instagram: string;
}
const trainers: Trainer[] = [{
  name: 'Kristina Sergaeva',
  role: 'Stretching- und Mobility-Coach · Aerial Stretching Coach',
  image: 'https://cdn.magicpatterns.com/uploads/kt1fgzwnfz6tf7ZxzLisVa/1.png.webp',
  instagram: 'https://www.instagram.com/kristina_sergaeva/'
}, {
  name: 'Anna Nadezhdina',
  role: 'Stretching- und Mobility-Coach',
  image: 'https://cdn.magicpatterns.com/uploads/wKmpxcTHboZNLPMR57xFxH/2.png.webp',
  instagram: 'https://www.instagram.com/annet_pole/'
}, {
  name: 'Angelina Kleinert',
  role: 'Stretching- und Mobility-Coach',
  image: 'https://cdn.magicpatterns.com/uploads/hNBdVSUdd5dubrQGaujjwV/4.png.webp',
  instagram: 'https://www.instagram.com/ange.lina.flex'
}, {
  name: 'Alexandra Manewitsch',
  role: 'Stretching- und Mobility-Coach',
  image: 'https://cdn.magicpatterns.com/uploads/nikXCT8AtnhnSGJrFFp3F9/image00006.jpeg.webp',
  instagram: 'https://www.instagram.com/'
}];
export function Trainers() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  return <section id="team" className="py-24 bg-white overflow-hidden" data-id="element-229">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-230">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-231">
          <span className="text-peony-600 font-semibold tracking-wider uppercase text-sm" data-id="element-232">
            Unser Team
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-dark-studio mt-2 mb-4" data-id="element-233">
            Deine Trainerinnen
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto" data-id="element-234">
            Leidenschaftliche Expertinnen, die dich auf deinem Weg zu mehr
            Flexibilität und Stärke begleiten.
          </p>
        </div>

        {/* Trainer Grid */}
        <div ref={ref} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-10" data-id="element-235">
          {trainers.map((trainer, index) => <div key={trainer.name} className={`flex flex-col items-center text-center group ${isVisible ? 'animate-fade-in-up' : 'opacity-0'}`} style={{
          animationDelay: `${index * 150}ms`
        }} data-id="element-236">
              {/* Circular Photo */}
              <div className="relative mb-6" data-id="element-237">
                <div className="w-56 h-56 rounded-full overflow-hidden ring-4 ring-peony-100 group-hover:ring-peony-300 transition-all duration-500 shadow-xl" data-id="element-238">
                  <img src={trainer.image} alt={trainer.name} className="w-full h-full object-cover object-top transform group-hover:scale-105 transition-transform duration-700" data-id="element-239" />
                </div>
                {/* Decorative ring */}
                <div className="absolute inset-0 rounded-full border-2 border-dashed border-peony-200 scale-110 group-hover:rotate-12 transition-transform duration-700 pointer-events-none" data-id="element-240"></div>
              </div>

              {/* Name */}
              <h3 className="text-xl font-bold text-dark-studio mb-1" data-id="element-241">
                {trainer.name}
              </h3>

              {/* Role */}
              <p className="text-gray-500 text-sm mb-5 max-w-[200px] leading-relaxed" data-id="element-242">
                {trainer.role}
              </p>

              {/* Instagram Button */}
              <a href={trainer.instagram} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-dark-studio flex items-center justify-center text-white hover:bg-peony-500 hover:scale-110 transition-all duration-300 shadow-md" aria-label={`${trainer.name} auf Instagram`} data-id="element-243">
                <Instagram size={18} data-id="element-244" />
              </a>
            </div>)}
        </div>
      </div>
    </section>;
}